<template>
  <router-link :to="route" custom v-slot="{ href, navigate, isActive, isExactActive }">
    <a
      :href="href"
      class="relative group w-full flex items-center pl-8 pr-3 py-2 text-sm font-medium hover:text-white rounded-r"
      :class="[
        (exact ? isExactActive : isActive)
          ? 'text-white bg-blue-600 bg-opacity-25'
          : 'text-gray-300 hover:bg-blue-600 hover:bg-opacity-25',
      ]"
      v-tip="{ content: tip }"
      @click="navigate"
    >
      <div
        class="absolute left-4 h-full w-px border-l"
        :class="[
          (exact ? isExactActive : isActive)
            ? 'border-blue-300'
            : 'border-gray-700 group-hover:border-blue-300',
        ]"
      ></div>
      <div>
        {{ label }}
      </div>
    </a>
  </router-link>
</template>

<script>
export default {
  props: {
    route: {
      type: [Object, String],
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    tip: {
      type: String,
      default: '',
    },
    exact: Boolean,
  },
};
</script>
